<template>
  <div>
    <h1>Editar Papel</h1>
    <b-card>
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("acl", ["role"]),
  },
  methods: {
    ...mapActions("acl", ["ActionNewRole", "ActionShow"]),
    async loadData(id) {
      try {
        await this.ActionShow(id);
      } catch (error) {
        this.$notifications.addNotification({
          message: error.data.responseMessage,
          icon: "exclamation-triangle",
          type: "danger",
        });
        this.$router.push({ name: "categorias_list" });
      }
    },
  },
  async created() {
    this.ActionNewRole();
    await this.loadData(this.$route.params.id);
  },
};
</script>

<style></style>
